import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDocumentService } from '../../../../apis/documents/useDocumentService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TDocument } from '../../../../apis/documents/documents.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentDocumentsKey = 'get-student-documents';

export const useStudentDocumentsHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TDocument[], TQueryError>
): UseQueryResult<TDocument[], TQueryError> => {
  const { getStudentDocuments } = useDocumentService();

  return useQuery<TDocument[], TQueryError>({
    queryKey: [getStudentDocumentsKey, params],
    queryFn: () => getStudentDocuments(params),
    enabled: true,
    ...options,
  });
};
